import React from 'react';
import { Link } from 'react-router-dom';
import image00 from "../images/G2 Radio Network.webp"

const NotFound = () => {

    return (
      <div>
        <h1 class="notFound">404</h1>
        <h2 class="notFound">Page Not Found!</h2>

        <img src={image00} class="notImage" />
        <div class="notFoundBtn">
          <button class="notFound">
            <Link id="notFound" to="/">
              Go To The Homepage
            </Link>
          </button>
        </div>
      </div>
    );

};

export default NotFound;